import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import CenteredState from './CenteredState';

function NoResults() {
  const { translate } = useTranslation();

  return (
    <CenteredState role="status" testId="global-search-no-results" minHeight={0}>
      <Typography variant="body2" color="text.secondary">
        {translate(LangEnum.GLOBAL_SEARCH_EMPTY_RESULTS)}
      </Typography>
    </CenteredState>
  );
}

export default NoResults;
